import { render, staticRenderFns } from "./payTest.vue?vue&type=template&id=697ba2eb&scoped=true&"
import script from "./payTest.vue?vue&type=script&lang=js&"
export * from "./payTest.vue?vue&type=script&lang=js&"
import style0 from "./payTest.vue?vue&type=style&index=0&id=697ba2eb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697ba2eb",
  null
  
)

export default component.exports